export const distinctObjectArray = (arr: any[], key: string) => {
    const result: any[] = [];

    for (const item of arr) {
        if (!result.find(i => i[key] === item[key])) {
            result.push(item);
        }
    }

    return result;
};